import React from "react";

const Logo = (props) => (
  <svg
    viewBox="0 0 1024 1024"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="42.5" y="42.5" width="939" height="939" rx="157.5" fill="black" />
    <path
      d="M136 662.859C136 662.859 350.467 662.859 391.228 662.859C393.025 662.859 394.548 661.62 395.027 659.888C478.2 359.252 480.68 196 503.035 196C534.742 196 509.891 495.267 572.447 702.036C672.71 1006.74 694.99 662.859 798.68 662.859C811.534 662.859 870.527 662.859 888 662.859"
      stroke="white"
      strokeWidth="94"
    />
  </svg>
);

export default Logo;
